import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function ProductShowcase() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Fundamentos Técnicos',
    desc: '7 gestos técnicos, biomecánica, correcciones y ejercicios progresivos.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Progresión por Niveles',
    desc: '4 niveles, criterios de avance, secuencias paso a paso y diagnóstico.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — 40 Clases Nivel Inicial',
    desc: 'Clases completas para principiantes. Objetivo, ejercicios, indicaciones, variantes.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Clases Intermedio y Avanzado',
    desc: '45 clases con sistemas de juego, rotaciones, táctica y simulación de partidos.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Metodología de Enseñanza',
    desc: 'Cómo explicar, corregir y motivar. Manejo de grupos grandes y ritmo de clase.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Planificación Profesional',
    desc: 'Planificaciones anuales/mensuales/semanales, seguimiento, evaluación y plantillas.'
  }];
  const includes = ['Planificación lista desde el día 1', 'Guion de clase completo', 'Indicaciones exactas de qué decir', 'Errores frecuentes y correcciones', 'Variantes por nivel', 'Progresión semana a semana', 'Adaptaciones para grupos grandes y mixtos', 'Español neutro para toda LATAM', 'Formatos variados, ninguna clase igual'];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <div className="text-center mb-5" data-id="element-129">
          <h2 className="text-sm md:text-lg font-black text-white mb-1 leading-tight" data-id="element-130">
            🏆 El sistema más completo de planificación para entrenadores de
            vóley de habla hispana
          </h2>
          <p className="text-lg md:text-2xl font-black text-brand-accent neon-glow mb-1" data-id="element-131">
            🏐 KIT COMPLETO VÓLEY LISTO
          </p>
          <p className="text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-132">
            6 tomos organizados por nivel y objetivo · 180+ clases con guion
            completo · 4 bonos estratégicos · todo listo para usar desde hoy
          </p>
        </div>

        <h3 className="text-center text-white font-black mb-3 text-sm" data-id="element-133">
          📘 Los 6 Tomos Técnicos
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 mb-5" data-id="element-134">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-white/5 rounded-lg p-3 hover:border-brand-accent/40 transition-colors group" data-id="element-135">
              <h4 className="text-xs md:text-sm font-black text-white mb-0.5 flex items-start group-hover:text-brand-accent transition-colors leading-tight" data-id="element-136">
                <span className="text-sm mr-1.5 leading-none" data-id="element-137">{tomo.icon}</span>
                <span data-id="element-138">{tomo.title}</span>
              </h4>
              <p className="text-[10px] md:text-xs text-gray-400 leading-relaxed font-medium ml-6" data-id="element-139">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-lg border border-brand-accent/30 overflow-hidden mb-5" data-id="element-140">
          <div className="bg-brand-accent py-2 px-4 text-center" data-id="element-141">
            <h4 className="text-xs md:text-sm font-black text-brand-dark" data-id="element-142">
              Cada tomo incluye:
            </h4>
          </div>
          <div className="p-4" data-id="element-143">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4" data-id="element-144">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-145">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-accent mr-2 shrink-0 mt-0.5" data-id="element-146" />
                  <span className="text-[10px] md:text-xs text-gray-300 font-medium leading-relaxed" data-id="element-147">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="bg-brand-card border border-white/10 rounded-lg p-4 text-center mb-5" data-id="element-148">
          <h3 className="text-xs md:text-sm font-black text-white mb-1" data-id="element-149">
            ¿Por qué funciona en cualquier país latinoamericano?
          </h3>
          <p className="text-[10px] md:text-xs text-gray-400 leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-150">
            Escrito en español neutro, sin regionalismos y con terminología
            técnica universal del vóley. Cubre principiantes, adultos, jóvenes
            en formación, grupos recreativos y competitivos.{' '}
            <span className="text-brand-accent font-bold" data-id="element-151">
              Creado para vos, dondequiera que estés.
            </span>
          </p>
        </div>

        <div className="w-full max-w-md mx-auto text-center" data-id="element-152">
          <Button onClick={scrollToCompra} className="text-sm md:text-base py-3 shadow-[0_0_30px_rgba(0,191,255,0.3)] w-full" data-id="element-153">
            🔥 QUIERO DEJAR DE IMPROVISAR — VER OFERTAS
          </Button>
        </div>
      </div>
    </section>;
}